import request from "@/utils/request";
import { AxiosPromise } from "axios";
import { MenuQuery, MenuVO, MenuForm } from "./types";
import { StatusTypeEnum } from "@/consts/config";

/**
 * 获取路由列表
 */
export function listUserMenus() {
  return request({
    url: "/system/menu",
    method: "get",
  });
}

/**
 * 获取菜单树形列表
 *
 * @param status  状态： 1 启用  0 禁用，不传全部
 */
export function listMenus(status?: StatusTypeEnum): AxiosPromise<MenuVO[]> {
  return request({
    url: "/system/menu/tree",
    method: "get",
    params: { status: status },
  });
}

/**
 * 获取菜单下拉树形列表
 */
export function listMenuOptions(): AxiosPromise<OptionType[]> {
  return request({
    url: "/api/v1/menus/options",
    method: "get",
  });
}

/**
 * 获取菜单表单数据
 *
 * @param id
 */
export function getMenuForm(id: number): AxiosPromise<MenuForm> {
  return request({
    url: `system/menu/${id}`,
    method: "get",
  });
}

/**
 * 添加菜单
 *
 * @param data
 */
export function addMenu(data: MenuForm) {
  return request({
    url: "/api/v1/menus",
    method: "post",
    data: data,
  });
}

/**
 * 修改菜单
 *
 * @param id
 * @param data
 */
export function updateMenu(data: MenuForm) {
  if (!data.menuId) {
    data.menuId = data.id;
  }
  const method = data.menuId ? "put" : "post";
  return request({
    url: "/system/menu",
    method,
    data: data,
  });
}

/**
 * 删除菜单
 *
 * @param id 菜单ID
 */
export function deleteMenu(id: number) {
  return request({
    url: `/system/menu/${id}`,
    method: "delete",
  });
}

export const getGroupData = () => {
  return request({
    url: "/system/menu/group",
    method: "get",
  });
};

export function checkMenuName(
  name: string,
  parentId: number,
  id: number
): AxiosPromise<any> {
  let url = `/system/menu/exists?name=${name}&parentId=${parentId}`;
  if (id) {
    url += `&id=${id}`;
  }
  return request({
    url,
    method: "get",
  });
}

export function changeStatus(id: number): AxiosPromise<any> {
  return request({
    url: `/system/menu/disableb/${id}/${status}`,
    method: "put",
  });
}
